import React, { createContext, useContext, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getLocalTodayString } from '../../../../components/CreationDate';
import { fetchChecklistBySlug, fetchSubmissionByDate } from '../../../../features/checks/checkActions';

const ChecksContext = createContext(null);

export function ChecksProvider({ children }) {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const [searchParams] = useSearchParams();

  const dateFromParams = searchParams.get('date');

  const [selectedDate, setSelectedDate] = useState(
    dateFromParams || getLocalTodayString()
  );

  const checklist = useSelector(
    (state) => state.checks.checklistsBySlug[slug] || null
  );

  const submission = useSelector(
    (state) => state.checks.currentSubmission
  );

  const loading = useSelector(
    (state) => state.checks.loading
  );

  const error = useSelector(
    (state) => state.checks.error
  );

  // Fetch checklist whenever slug changes
  useEffect(() => {
    if (!slug) return;

    dispatch(fetchChecklistBySlug(slug));
  }, [slug, dispatch]);

  // Fetch submission whenever checklist/date changes
  useEffect(() => {
    if (!checklist?.id || !selectedDate) return;

    dispatch(
      fetchSubmissionByDate({
        checklistId: checklist.id,
        creationDate: selectedDate,
      })
    );
  }, [checklist?.id, selectedDate, dispatch]);

  const value = {
    slug,
    selectedDate,
    setSelectedDate,
    checklist,
    submission,
    loading,
    error,
  };

  return (
    <ChecksContext.Provider value={value}>
      {children}
    </ChecksContext.Provider>
  );
}

export function useChecks() {
  const context = useContext(ChecksContext);

  if (!context) {
    throw new Error('useChecks must be used inside ChecksProvider');
  }

  return context;
}